import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "jobs-panel" }
const _hoisted_2 = {
  key: 1,
  class: "jobs-panel__no-access"
}
const _hoisted_3 = { class: "jobs-panel__no-access-label" }

import {computed} from "vue";
import JobsPanelSearch from "@/components/main/jobs-panel/JobsPanelSearch.vue";
import JobsPanelList from "@/components/main/jobs-panel/JobsPanelList.vue";
import AppLoader from "@/components/common/AppLoader.vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import {jobsStore} from "@/store/jobs";
import {useJobsAccess} from "@/composables/useJobsAccess";


export default /*@__PURE__*/_defineComponent({
  __name: 'JobsPanel',
  setup(__props) {

const store = jobsStore()

const isLoading = computed(() => store.jobsLoading)

const {isJobsDenied, deniedText} = useJobsAccess()

const loaderStyle = computed(() => ({
	'background-color': 'rgba(255, 255, 255, 0.5)'
}))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isLoading.value)
      ? (_openBlock(), _createBlock(AppLoader, {
          key: 0,
          style: _normalizeStyle(loaderStyle.value)
        }, null, 8, ["style"]))
      : _createCommentVNode("", true),
    (_unref(isJobsDenied))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(AppIcon, {
            class: "jobs-panel__no-access-icon",
            name: "invalid",
            width: "24px",
            color: "#979797"
          }),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(deniedText)), 1)
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createVNode(JobsPanelSearch),
          _createVNode(JobsPanelList)
        ], 64))
  ]))
}
}

})